import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/backgrounds",
        name: "backgrounds",
        component: () => import("@/components/backgrounds/_Backgrounds.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewBackgroundsUI,
            breadcrumbs: {
                icon: "backgrounds-icon",
                paths: []
            },
            title: "navbar.backgrounds"
        }
    },
    {
        path: "/backgrounds/create",
        name: "createbackground",
        component: () => import("@/components/backgrounds/_BackgroundForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateBackground,
            breadcrumbs: {
                icon: "backgrounds-icon",
                paths: [
                    ["/backgrounds", i18n.t("background.title")]
                ]
            },
            title: "background.createnewbackground"
        },
        props: true
    },
    {
        path: "/backgrounds/:backgroundId/update",
        name: "updatebackground",
        component: () => import("@/components/backgrounds/_BackgroundForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateBackground,
            breadcrumbs: {
                icon: "backgrounds-icon",
                paths: [
                    ["/backgrounds", i18n.t("background.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/background/:backgroundId/preview",
        name: "backgroundpreview",
        component: () => import("@/components/backgrounds/_BackgroundPreview.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewBackgroundsUI,
            layout: () => import("@/components/layouts/_BasicLayout.vue"),
            title: "common.preview"
        },
        props: true
    }
];
